import React from 'react';
import styles from 'components/info/index.module.scss';
import classNames from 'classnames/bind';

const cx = classNames.bind(styles);

/**
 * @param children
 * @param withArrow (boolean)
 * @param onClick (function)
 * @param theme ('orange'|'blue')
 * @param customStyle  (object)
 */

const Info = ({ children, withArrow, onClick, theme = 'orange', customStyle = {} }) => {
  const info = cx({
    info: true,
    [theme]: true,
  });
  return (
    <div style={customStyle} className={info} onClick={onClick}>
      {children}
      {withArrow ? <span className={styles.arrow} /> : <></>}
    </div>
  );
};

export default Info;
